import React from "react";
import { MultiColumnList } from "@folio/stripes/components";
import { useIntl } from "react-intl";
export var ProductMeasuresTable = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var unitMeasures = _a.unitMeasures, cartonMeasures = _a.cartonMeasures, palletMeasures = _a.palletMeasures;
    var formatMessage = useIntl().formatMessage;
    var measuresData = [
        {
            id: "unit",
            type: formatMessage({ id: "ui-br-agency.product.measures.unit.label" }),
            height: ((_b = unitMeasures === null || unitMeasures === void 0 ? void 0 : unitMeasures.height) === null || _b === void 0 ? void 0 : _b.toString()) || "-",
            width: ((_c = unitMeasures === null || unitMeasures === void 0 ? void 0 : unitMeasures.width) === null || _c === void 0 ? void 0 : _c.toString()) || "-",
            thickness: ((_d = unitMeasures === null || unitMeasures === void 0 ? void 0 : unitMeasures.thickness) === null || _d === void 0 ? void 0 : _d.toString()) || "-",
            weight: ((_e = unitMeasures === null || unitMeasures === void 0 ? void 0 : unitMeasures.weight) === null || _e === void 0 ? void 0 : _e.toString()) || "-",
        },
        {
            id: "carton",
            type: formatMessage({ id: "ui-br-agency.product.measures.carton.label" }),
            height: ((_f = cartonMeasures === null || cartonMeasures === void 0 ? void 0 : cartonMeasures.height) === null || _f === void 0 ? void 0 : _f.toString()) || "-",
            width: ((_g = cartonMeasures === null || cartonMeasures === void 0 ? void 0 : cartonMeasures.width) === null || _g === void 0 ? void 0 : _g.toString()) || "-",
            thickness: ((_h = cartonMeasures === null || cartonMeasures === void 0 ? void 0 : cartonMeasures.thickness) === null || _h === void 0 ? void 0 : _h.toString()) || "-",
            weight: ((_j = cartonMeasures === null || cartonMeasures === void 0 ? void 0 : cartonMeasures.weight) === null || _j === void 0 ? void 0 : _j.toString()) || "-",
        },
        {
            id: "pallet",
            type: formatMessage({ id: "ui-br-agency.product.measures.pallet.label" }),
            height: ((_k = palletMeasures === null || palletMeasures === void 0 ? void 0 : palletMeasures.height) === null || _k === void 0 ? void 0 : _k.toString()) || "-",
            width: ((_l = palletMeasures === null || palletMeasures === void 0 ? void 0 : palletMeasures.width) === null || _l === void 0 ? void 0 : _l.toString()) || "-",
            thickness: ((_m = palletMeasures === null || palletMeasures === void 0 ? void 0 : palletMeasures.thickness) === null || _m === void 0 ? void 0 : _m.toString()) || "-",
            weight: ((_o = palletMeasures === null || palletMeasures === void 0 ? void 0 : palletMeasures.weight) === null || _o === void 0 ? void 0 : _o.toString()) || "-",
        },
    ];
    var columnMapping = {
        id: "ID",
        type: formatMessage({ id: "ui-br-agency.product.measures.type.label" }),
        height: formatMessage({ id: "ui-br-agency.product.measures.height.label" }),
        width: formatMessage({ id: "ui-br-agency.product.measures.width.label" }),
        thickness: formatMessage({
            id: "ui-br-agency.product.measures.thickness.label",
        }),
        weight: formatMessage({ id: "ui-br-agency.product.measures.weight.label" }),
    };
    var visibleColumns = ["type", "height", "width", "thickness", "weight"];
    return (React.createElement(MultiColumnList, { contentData: measuresData, visibleColumns: visibleColumns, columnMapping: columnMapping, interactive: false, columnWidths: {
            type: "20%",
            height: "20%",
            width: "20%",
            thickness: "20%",
            weight: "20%",
        } }));
};
